import { useErrorContext } from '../../context/ErrorContext';
import Validation from '../../validation/Authentication/Validation.js';
import { Axios, useState, useNavigate, FaEyeSlash } from '../../common/common';
import Navigations from '../../common/useNavigation.js';
import { useEffect } from 'react';
import { showToast } from '../../Utils/toastUtils.js';

const Midlogin = () => {

    const { navigateRegisteration, navigateMain, navigateOTP, navigateSellerProductAttributes, navigateUserType, navigateDashboard, navigateBuyerBusinessdetails } = Navigations();
    const navigate = useNavigate();
    const { validateLoginForm } = Validation;
    const { setValidationError, clearAllErrors } = useErrorContext();

    const [type, setType] = useState('password');
    const [icon, setIcon] = useState(FaEyeSlash);

    const [values, setValue] = useState({ emailnmobi: "", passWord: "" });
    const [isLoading, setisLoading] = useState(false);
    const [isDisabled, setisDisabled] = useState(false);
    const navigateSellerPersonaldetails = (type) => { navigate(`/Business-details/${type}`); };


    useEffect(() => {
        showToast('', '');
    }, [])

    // Reusable function to handle validation and set errors
    const validateAndSetErrors = (values) => {
        const validationErrors = validateLoginForm(values);
        Object.keys(validationErrors).forEach(field => setValidationError(field, validationErrors[field]));
        return validationErrors;
    };

    const handleChange = e => {
        const { name, value } = e.target;
        setValue(prev => ({ ...prev, [name]: value }));
        const validationErrors = validateAndSetErrors(values);
        if (Object.keys(validationErrors).length === 0) {
            clearAllErrors();
        }
    };
    const handleSubmit = e => {
        e.preventDefault();
        const validationErrors = validateAndSetErrors(values);
        if (Object.keys(validationErrors).length === 0) {

            clearAllErrors();
            checkLogin();
        }
    };
    const navigateRegisterations = () => {
        setisLoading(true);
        navigateRegisteration();
    }
    const checkLogin = () => {
        const { emailnmobi, passWord } = values;


        if (!emailnmobi || !passWord) {
            showToast('Please fill all required fields', 'error');
            return;
        }

        setisLoading(true);
        setisDisabled(true);

        Axios.post(`${process.env.REACT_APP_API_URL}/api/authlogin`, { Emailmobile: emailnmobi, pswd: passWord, app: 0 }, { withCredentials: true })
            .then(handleLoginResponse)
            .catch(handleLoginError);
    };

    const handleLoginResponse = (res) => {
        const result = res.data;
        // console.log({ result: result });
        // console.log(result.data);

        if (result.success === 1) {
            handleSuccessfulLogin(result);
        }
        else if (result.success === 0 && (result.data && Object.keys(result.data).length > 0)) {
            const userType = result.data['userType'];
            const usertypeArray = typeof userType === 'string' ? userType.split(',').map(str => parseInt(str.trim())).filter(num => !isNaN(num)) : [];
            const hasOne = usertypeArray.includes(1);
            const hasTwo = usertypeArray.includes(2);
            const otp_verified_flag = result.data['otp_verified_flag'];
            const personal_details_flag = result.data['personal_details_flag'];
            // const email_verified_flag = result.data['email_verified_flag'];
            const user_attributes_flag = result.data['user_attributes_flag'];
            if (parseInt(otp_verified_flag) === 0) {
                // console.log('1');
                setTimeout(() => {
                    navigateOTP();
                }, 3000);
            }
            else if (usertypeArray.length < 0 || usertypeArray.length === 0) {
                // console.log('2');
                setTimeout(() => {
                    navigateUserType();
                }, 3000);
            }
            else if (parseInt(personal_details_flag) === 0) {
                // console.log('3');
                if (hasOne && hasTwo) {
                    setTimeout(() => {
                        navigateSellerPersonaldetails('seller');
                    }, 3000);
                }
                else if (hasOne) {
                    setTimeout(() => {
                        navigateSellerPersonaldetails('buyer');
                    }, 3000);
                }
                else {
                    setTimeout(() => {
                        navigateUserType();
                    }, 3000);
                }
            }
            else if (parseInt(user_attributes_flag) === 0 && (hasOne && hasTwo)) {
                // console.log('4');
                setTimeout(() => {
                    navigateSellerProductAttributes();
                }, 3000);
            }
            else if (parseInt(user_attributes_flag) === 1 && (hasOne && hasTwo)) {
                // console.log('5');
                setTimeout(() => {
                    navigateDashboard('seller');
                }, 3000);
            }
            else if (hasOne && personal_details_flag === 1) {
                // console.log(hasOne +'/'+ personal_details_flag);
                setTimeout(() => {
                    navigateDashboard('buyer');
                }, 3000);
            }

            else if (userType !== '' && parseInt(personal_details_flag) !== 0 && parseInt(otp_verified_flag) !== 0 && parseInt(user_attributes_flag) !== 0) {
                // console.log('7');
                setTimeout(() => {
                    navigateDashboard('buyer');
                }, 3000);
            }
            else {
                // console.log('8');
                setTimeout(() => {
                    navigateMain();
                }, 3000);
            }
            // console.log('0');

        }
        else {
            showToast(result.message, 'error');
        }

        resetLoadingState();
    };

    const handleLoginError = (err) => {
        // console.error(err);
        showToast(err.response?.data?.message || err.message || "An error occurred", 'error');
        resetLoadingState();
    };

    const handleSuccessfulLogin = (result) => {
        const { message, businessData, data: { personal_details_flag, otp_verified_flag, user_attributes_flag, userType } } = result;
        // console.log(result);
        const usertypeArray = typeof userType === 'string' ? userType.split(',').map(str => parseInt(str.trim())).filter(num => !isNaN(num)) : [];
        const hasOne = usertypeArray.includes(1);
        const hasTwo = usertypeArray.includes(2);
        // dispatch(loginSuccess(result));
        showToast(message, 'success');
        if (parseInt(otp_verified_flag) === 0) {
            setTimeout(() => {
                navigateOTP();
            }, 3000);
        }
        else if (usertypeArray.length < 0 || usertypeArray.length === 0) {
            setTimeout(() => {
                navigateUserType();
            }, 3000);
        }
        else if (parseInt(personal_details_flag) === 0) {
            if (hasOne && hasTwo) {
                setTimeout(() => {
                    navigateSellerPersonaldetails('seller');
                }, 3000);
            }
            else if (hasOne) {
                setTimeout(() => {
                    navigateSellerPersonaldetails('buyer');
                }, 3000);
            }
            else {
                setTimeout(() => {
                    navigateUserType();
                }, 3000);
            }
        }
        else if (parseInt(user_attributes_flag) === 0 && (hasOne && hasTwo)) {
            setTimeout(() => {
                navigateSellerProductAttributes();
            }, 3000);
        }
        else if (parseInt(user_attributes_flag) === 1 && (hasOne && hasTwo)) {
            setTimeout(() => {
                navigateDashboard('seller');
            }, 3000);
        }
        else if (hasOne && personal_details_flag === 1) {
            if (businessData && Object.keys(businessData).length > 0) {
                setTimeout(() => {
                    navigateDashboard('buyer');
                }, 3000);
            } else {
                // navigateBuyerBusinessdetails('buyer');
                if (hasOne && hasTwo) {
                    setTimeout(() => {
                        navigateBuyerBusinessdetails('seller');
                    }, 3000);
                }
                else if (hasOne) {
                    setTimeout(() => {
                        navigateBuyerBusinessdetails('buyer');
                    }, 3000);
                }
                else {
                    setTimeout(() => {
                        navigateUserType();
                    }, 3000);
                }
            }
        }

        
        else if (userType !== '' && parseInt(personal_details_flag) !== 0 && parseInt(otp_verified_flag) !== 0 && parseInt(user_attributes_flag) !== 0) {
            setTimeout(() => {
                navigateDashboard('buyer');
            }, 3000);
        }
        else {
            setTimeout(() => {
                navigateMain();
            }, 3000);
        }
        clearForm();
    };

    // const showToast = (message, type) => {
    //     const options = {
    //         position: 'top-center',
    //         autoClose: 5000,
    //         hideProgressBar: true,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //         theme: 'colored',
    //     };

    //     if (type === 'success') {
    //         toast.success(message, options);
    //     } else {
    //         toast.error(message, options);
    //     }
    // };

    const resetLoadingState = () => {
        setisLoading(false);
        setisDisabled(false);
    };

    const clearForm = () => {
        values.emailnmobi = '';
        values.passWord = '';
    };

    const handleToggle = () => {
        if (type === 'password') { setType('text'); }
        else { setType('password'); }
    }

    return { handleSubmit, handleChange, values, type, setType, icon, setIcon, handleToggle, isLoading, setisLoading, isDisabled, setisDisabled, useErrorContext, navigateRegisterations };
};

export default Midlogin;
